import React from "react";
import { Box, Typography, Grid, IconButton } from "@mui/material";
import { Facebook, Instagram, Twitter, LinkedIn } from "@mui/icons-material";

function Footer() {
  return (
    <Box
      sx={{
        background: "#0F172A",
        color: "#fff",
        mt: 5,
        pt: 5,
        pb: 3,
        px: 5,
      }}
    >
      <Grid container spacing={4}>

        {/* 🔹 Company Info */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            EduStore
          </Typography>
          <Typography variant="body2" sx={{ color: "#94A3B8" }}>
            Providing high-quality educational supplies including classroom furniture,
            IT equipment, and laboratory essentials for institutions.
          </Typography>
        </Grid>

        {/* 🔹 Categories */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" gutterBottom>
            Categories
          </Typography>
          <Typography variant="body2">Classroom Furniture</Typography>
          <Typography variant="body2">Administration Supplies</Typography>
          <Typography variant="body2">IT Equipment</Typography>
          <Typography variant="body2">Laboratory Equipment</Typography>
        </Grid>

        {/* 🔹 Contact */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" gutterBottom>
            Contact
          </Typography>
          <Typography variant="body2">Email: support@edustore.com</Typography>
          <Typography variant="body2">Phone: +91 9876543210</Typography>
          <Typography variant="body2">Location: India</Typography>

          {/* Social Icons */}
          <Box mt={2}>
            <IconButton sx={{ color: "#fff" }}>
              <Facebook />
            </IconButton>
            <IconButton sx={{ color: "#fff" }}>
              <Instagram />
            </IconButton>
            <IconButton sx={{ color: "#fff" }}>
              <Twitter />
            </IconButton>
            <IconButton sx={{ color: "#fff" }}>
              <LinkedIn />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      {/* Bottom Line */}
      <Box mt={4} textAlign="center">
        <Typography variant="body2" sx={{ color: "#94A3B8" }}>
          © {new Date().getFullYear()} EduStore. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;